import { useQuery, queryOptions } from "@tanstack/react-query";
import { Flame } from "lucide-react";
import { getSoldStats } from "@/lib/sold-stats.functions";

const soldStatsQuery = queryOptions({
  queryKey: ["sold-stats"],
  queryFn: () => getSoldStats(),
  staleTime: 10 * 60 * 1000,
});

type Props = {
  variant?: "dark" | "light";
  className?: string;
};

/** Shows "🔥 X sålda denna vecka" — only when > 1. Real data, never faked. */
export function SoldTodayBadge({ variant = "dark", className = "" }: Props) {
  const { data } = useQuery(soldStatsQuery);
  const n = data?.last7d ?? 0;
  if (n <= 1) return null;

  const styles =
    variant === "light"
      ? "border-border bg-card text-foreground"
      : "border-background/25 bg-background/10 text-background backdrop-blur-md";

  const label = `${n} sålda denna vecka`;

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] ${styles} ${className}`}
      title="Antal fordon som försvunnit ur lagret senaste 7 dagarna"
    >
      <Flame size={12} className="text-orange-500" />
      <span className="tabular-nums">{label}</span>
    </span>
  );
}
